var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "green-check-small.e67a9f5a.png","uri@2x": __webpack_public_path__ + "green-check-small.fba0a039.png","uri@3x": __webpack_public_path__ + "green-check-small.21374603.png",
    width: 20,
    height: 20
});